var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8628 7.1181C18.6668 6.79308 18.3903 6.52404 18.0601 6.33696C17.7298 6.14987 17.357 6.05104 16.9774 6.05H14.3V3.85C14.3 3.55826 14.1841 3.27847 13.9778 3.07218C13.7715 2.86589 13.4917 2.75 13.2 2.75H2.2C0.9867 2.75 0 3.7367 0 4.95V15.95C0 16.7706 0.4576 17.4801 1.1253 17.8574C1.2606 19.8583 2.915 21.45 4.95 21.45C6.8849 21.45 8.4744 20.0101 8.7439 18.15H12.1561C12.4256 20.0101 14.0151 21.45 15.95 21.45C17.8849 21.45 19.4744 20.0101 19.7439 18.15H19.8C21.0133 18.15 22 17.1633 22 15.95V12.65C22.0002 12.4504 21.9458 12.2545 21.8427 12.0835L18.8628 7.1181ZM14.3 8.25H16.9774L18.9574 11.55H14.3V8.25ZM4.95 19.25C4.0403 19.25 3.3 18.5097 3.3 17.6C3.3 16.6903 4.0403 15.95 4.95 15.95C5.8597 15.95 6.6 16.6903 6.6 17.6C6.6 18.5097 5.8597 19.25 4.95 19.25ZM15.95 19.25C15.0403 19.25 14.3 18.5097 14.3 17.6C14.3 16.6903 15.0403 15.95 15.95 15.95C16.8597 15.95 17.6 16.6903 17.6 17.6C17.6 18.5097 16.8597 19.25 15.95 19.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicles);
export default __webpack_public_path__ + "static/media/vehicles.90cb868f394c9d97176b5dddf2dec49d.svg";
export { ForwardRef as ReactComponent };